import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React, { FunctionComponent, useState } from "react";
import { AvatarCard, AvatarCardProps } from "./AvatarCard";
import AttachmentIcon from "@material-ui/icons/Attachment";
import { FileCard, FileCardProps } from "./FileCard";
import { Drawer } from "@material-ui/core";

// TODO: needs to be rewritten using similar style definitions like in other parts of the system
const useStyle = makeThemedStyles("AnalysisCard", (theme) => ({
  description: {
    outline: "none",
    userSelect: "text",
    color: "rgba(63, 69, 79, 1)",
    fontSize: "15px",
  },
  AnalysisCard: {
    padding: "2.74em 2.74em 2.63em 2.74em",
    width: "100%",
    minWidth: "450px",
    maxWidth: "700px",
    background: "rgba(0,0,0,0.04)",
    borderRadius: "1.98em",
    "& .header": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingInlineStart: "20px",
      "& .date": {
        color: "#4C5157",
        margin: "-0.15em -0.15em 0 0",
        opacity: "0.8",
        fontSize: "1.6em",
        lineHeight: "20px",
        letterSpacing: "0.04375px",
        mixBlendMode: "normal",
      },
    },
    "& .files": {
      display: "flex",
      flexWrap: "wrap",
      gap: "5px",
      "& .attachment": {
        color: "rgba(63, 69, 79, 1)",
        height: "42.13px",
        minWidth: "59px",
        cursor: "pointer",
        display: "flex",
        padding: "0.5em",
        position: "relative",
        fontSize: "1.5em",
        background: "rgb(250,250,250)",
        textAlign: "center",
        alignItems: "center",
        borderColor: "rgb(232,234,237)",
        borderStyle: "solid",
        borderWidth: "1px",
        marginRight: "0.3em",
        borderRadius: "8px",
        justifyContent: "space-between",
        fill: "#8FB8CC",
        "& .icon": {
          transform: "rotate(-45deg)",
          width: "25px",
          height: "25px",
        },
      },
    },
  },
  drawer: {
    display: "flex",
    gap: "10px",
    padding: "10px",
    flexWrap: "wrap",
  },
}));

interface AnalysisCardProps {
  date?: string;
  description?: string;
  userData?: AvatarCardProps;
  files?: FileCardProps[];
}

const AnalysisCard = (props: React.PropsWithChildren<AnalysisCardProps>) => {
  const styles = useStyle();
  const files = props.files || [];
  const { userData } = props;
  const subFileList = files.length > 2 ? files.slice(0, 2) : files;
  const nUnViewedFiles = files.length > 2 ? files.length - 2 : 0;
  const [openDrawer, setopenDrawer] = useState(false);
  return (
    <div className={styles.AnalysisCard}>
      <div className="header">
        {userData ? <AvatarCard {...userData} /> : null}
        <div className="date">{props.date}</div>
      </div>
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: props.description || "" }}
      />
      <div className="files">
        {subFileList.map((f) => (
          <FileCard {...f} />
        ))}
        {nUnViewedFiles > 0 ? (
          <div
            className="attachment"
            title="See more files"
            onClick={() => setopenDrawer(true)}
          >
            <AttachmentIcon className="icon" />
            <div>+{nUnViewedFiles}</div>
          </div>
        ) : null}
      </div>
      <Drawer
        anchor="bottom"
        open={openDrawer}
        onClose={() => setopenDrawer(false)}
      >
        <div className={styles.drawer}>
          {files.map((f) => (
            <FileCard {...f} />
          ))}
        </div>
      </Drawer>
      {props.children}
    </div>
  );
};

export default AnalysisCard;
